// extracted by mini-css-extract-plugin
export default {"legalNotice":"_6ijwxDFee53asg5eJd0ZCJ"};